import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

import { t } from '../../../helpers/t';
import { listingFeatureIconMap } from '../../../helpers/fontAwesome.js';
import { Modal } from '../../../helpers/modal';

export function ListingAmenities() {
  const { listing_features } = useSelector((state) => state.listing);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const MAX_VISIBLE_AMENITIES = 10;
  const visibleAmenities = listing_features.slice(0, MAX_VISIBLE_AMENITIES);
  const hasMoreAmenities = listing_features.length > MAX_VISIBLE_AMENITIES;

  const handleShowAll = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <div className="px-4 md:px-0 py-6">
      <h2 id="amenities" className="text-stone-900 text-2xl font-semibold mb-4">
        {t('listings.show.sections.features.header')}
      </h2>
      <div className="grid grid-cols-2 gap-x-3 gap-y-3 sm:grid-cols-3 mb-4">
        {visibleAmenities.map((feature, index) => (
          <div
            key={`listing-feature-${index}`}
            className="border-0 border-l-3 border-b border-solid border-stone-200 flex flex-col items-start rounded-lg py-3 px-3 bg-stone-50 justify-center hover:bg-stone-100 hover:border-stone-300 hover:shadow-sm transition-all duration-200"
            itemProp="additionalProperty"
            itemScope
            itemType="http://schema.org/PropertyValue"
          >
            <meta itemProp="name" content="Space Amenity" />
            <div className="font-light parent-project-type text-sm text-stone-900 flex items-center justify-start" itemProp="value">
              {feature.icon && listingFeatureIconMap[feature.icon] && (
                <div className="w-5 mr-3 flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={listingFeatureIconMap[feature.icon]} className="text-lg text-stone-700" aria-hidden />
                </div>
              )}
              <span className="text-left leading-relaxed">{feature.name}</span>
            </div>
          </div>
        ))}
      </div>
      {hasMoreAmenities && (
        <button
          onClick={handleShowAll}
          className="inline-flex items-center py-3 px-4 bg-stone-100 hover:bg-stone-200 rounded-lg transition-all duration-200 text-stone-700 hover:text-stone-900 font-medium"
          style={{ border: '1px solid #d6d3d1', borderRadius: '8px' }}
        >
          <span>{t('listings.show.sections.features.showAll')} ({listing_features.length})</span>
          <FontAwesomeIcon icon={faAngleRight} className="ml-2" aria-hidden />
        </button>
      )}
      <Modal
        id="listing-amenities-modal"
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        header={(
          <h2 id="amenities" className="text-stone-900 text-xl font-medium m-0">
            {t('listings.show.sections.features.header')}
          </h2>
        )}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
          {listing_features.map((feature, index) => (
            <div
              key={`modal-listing-feature-${index}`}
              className="flex items-center p-3 hover:bg-stone-100 transition-colors"
            >
              {feature.icon && listingFeatureIconMap[feature.icon] && (
                <div className="w-6 mr-3 flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={listingFeatureIconMap[feature.icon]} className="text-lg text-stone-700" aria-hidden />
                </div>
              )}
              <span className="text-stone-900 font-light text-base">{feature.name}</span>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}
